// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  app_url: 'http://findoit-app.slowcode.io/',
  api_url: 'http://findoit.slowcode.io/api/',
  img_url: 'http://findoit.slowcode.io',
  x_static_key: 'd2312cb8-f19e-479a-b633-ea2bec6142f2',
};

// export const environment = {
//   production: false,
//   app_url: 'http://localhost:8100/',
//   api_url: 'http://localhost:8000/api/',
//   img_url: 'http://localhost:8000',
//   x_static_key: 'd2312cb8-f19e-479a-b633-ea2bec6142f2',
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
